import type { UseEmblaCarouselType } from 'embla-carousel-react'
import useEmblaCarousel from 'embla-carousel-react'
import { useCallback, useEffect, useState } from 'react'

type EmblaCarouselHookResult = {
  emblaRef: UseEmblaCarouselType[0]
  emblaApi: UseEmblaCarouselType[1]
  selectedIndex: number
}

export function useEmblaCarouselWithIndex(
  options?: Parameters<typeof useEmblaCarousel>[0],
  plugins?: Parameters<typeof useEmblaCarousel>[1],
): EmblaCarouselHookResult {
  const [emblaRef, emblaApi] = useEmblaCarousel(options, plugins)
  const [selectedIndex, setSelectedIndex] = useState(0)

  const onSelect = useCallback(() => {
    if (!emblaApi) return
    setSelectedIndex(emblaApi.selectedScrollSnap())
  }, [emblaApi])

  useEffect(() => {
    if (!emblaApi) return

    onSelect() // Set initial index
    emblaApi.on('select', onSelect)

    return () => {
      emblaApi.off('select', onSelect)
    }
  }, [emblaApi, onSelect])

  return { emblaRef, emblaApi, selectedIndex }
}
